import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.jsx'
import './index.css'
import 'leaflet/dist/leaflet.css';
import { ConfigProvider } from 'antd'
import idID from 'antd/locale/id_ID';
import pallete from './utils/pallete.js'

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <ConfigProvider
      locale={idID}
      // drawer={{ 
      //   styles: {
      //     wrapper:{x
      //       margin: 15,
      //     },
      //     content: {
      //       borderRadius: 8
      //     }
      //   }
      // }}
      theme={{
        token: {
          colorPrimary: pallete.primary.main,
          fontFamily: 'Lato',
        },
        components: {
          Menu: {
            itemColor: pallete.grey[500],
            itemHoverColor: pallete.primary.main,
            collapsedIconSize: 15,
          },
          Table: {
            headerSplitColor: '',
            headerBorderRadius: 0,
          },
          Form: {
            itemMarginBottom: 16,
            verticalLabelMargin: "0 0 -3px 0",
            labelFontSize: 13,
            labelColor: pallete.grey[800],
          },
        }
      }}
    >
      <App />
    </ConfigProvider>
  </StrictMode>,
)
